<template>
    <div class="wrapper">
        <NavBar />
        <Menu />
        <!-- Spinner Start -->
        <div id="spinner" v-if="halamanloading"
            class="show bg-white position-fixed translate-middle w-100 vh-100 top-50 start-50 d-flex align-items-center justify-content-center"
            style="opacity: 0.5;">
            <div class="spinner-border text-danger" style="width: 3rem; height: 3rem;" role="status">
                <span class="sr-only">Loading...</span>
            </div>
        </div>
        <!-- Spinner End -->
        <div class="modal fade" id="costumModalLegendaData" data-easein="flipBounceYIn" tabindex="-1" role="dialog"
            aria-labelledby="costumModalLabel" aria-hidden="true" data-backdrop="static" data-keyboard="false"
            style="background: rgba(240, 248, 255, 0.1);width: 100vw;height: 98%;">
            <div class="modal-dialog modal-fullscreen">
                <div class="modal-content" style="height: auto;min-width: 95vw; min-height: 98%;">
                    <div class="modal-header">
                        <h4 class="modal-title">Data Hari Libur Nasional</h4>
                        <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                            <span aria-hidden="true">&times;</span>
                        </button>
                    </div>
                    <div class="modal-body text-justify" style="height: auto;min-width: 95vw; min-height: 98%;">
                        <div class="row px-2">
                            <div class="col-sm-1">Cari Tahun</div>
                            <div class="col-sm-1">
                                <input type="number" class="form-control form-control-sm" id="tahunsekarang"
                                    name="tahunsekarang" placeholder="Tahun" v-model="tahunsekarang">
                            </div>
                            <div class="col-sm-1">
                                <button type="button" class="btn btn-success3 btn-sm lebar2 text-white"
                                    @click="carilibur()"><i class="fas fa-search"></i>
                                    Cari</button>
                            </div>
                            <div class="col-sm-12">
                                &nbsp;
                            </div>
                            <div class="col-sm-12">
                                <div class="table-responsive table-wrapper">
                                    <table class="table m-0" id="tabeldatadetail" style="font-size: smaller;">
                                        <thead>
                                            <tr>
                                                <th style="width: 50px;">No</th>
                                                <th style="width: 200px;">Tanggal</th>
                                                <th style="width: 200px;">Nama</th>
                                            </tr>
                                        </thead>
                                        <template v-for="(datalist, urutlist) in dataapi" :key="urutlist">
                                            <tbody>
                                                <tr>
                                                    <td class="text-center">{{ urutlist + 1 }}</td>
                                                    <td>{{ G_formatDateNonWIB(datalist.date) }}</td>
                                                    <td>{{ datalist.name }}</td>
                                                </tr>
                                            </tbody>
                                        </template>
                                    </table>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="modal-footer justify-content-between">
                        <button type="button" class="btn btn-success3 btn-sm lebar2 text-white"
                            @click="simpantanggal()"><i class="fas fa-plus-square"></i>
                            Simpan</button>
                        <button type="button" class="btn btn-danger3 btn-sm lebar2 text-white" data-dismiss="modal"> <i
                                class="far fa-times-circle"></i>
                            Tutup</button>
                    </div>
                </div>
            </div>
        </div>
        <div class="content-wrapper py-3">
            <div class="content-header">
                <div class="container-fluid">
                    <div class="row mb-2">
                        <div class="col-sm-6 wow fadeInDown">
                            <h5>Pengaturan Hari Libur</h5>
                        </div>
                        <div class="col-sm-6 wow fadeInDown">
                            <ol class="breadcrumb float-sm-right">
                                <li class="breadcrumb-item"><a href="/Dashboard">Home </a></li>
                                <li class="breadcrumb-item active">Pengaturan Hari Libur</li>
                            </ol>
                        </div>
                    </div><!-- /.row -->
                </div><!-- /.container-fluid -->
            </div>
            <!-- /.content-header -->
            <div class="content">
                <div class="container-fluid">
                    <div class="row">
                        <div class="col-sm-12 wow fadeInDown">
                            <div class="card cardputih">
                                <div class="card-header border-transparent">
                                    <div class="col-sm-3 float-left pb-2">
                                        <button type="button" class="btn btn-primary btn-sm text-white lebar2"
                                            @click="prosesdata('Tambah')" data-toggle="tooltip" data-placement="left"
                                            title="Tambah data..">
                                            <i class="fas fa-plus"></i> Tambah
                                        </button>
                                    </div>
                                    <div class="col-sm-3 float-left pb-2">
                                        <button type="button" class="btn btn-success btn-sm text-white lebar2"
                                            @click="importapi()" data-toggle="tooltip" data-placement="left"
                                            title="Tambah data..">
                                            <i class="fas fa-plus"></i> Import Libur Nasional
                                        </button>
                                    </div>
                                    <div class="col-sm-5 float-left pb-2">
                                        <input type="text" v-model="carikata" class="form-control form-control-sm"
                                            placeholder="Masukkan Kata Kunci Pencarian">
                                    </div>
                                    <div class="card-tools">
                                        <button type="button" class="btn btn-tool" data-card-widget="collapse">
                                            <i class="fas fa-minus"></i>
                                        </button>
                                    </div>
                                </div>
                                <div class="card-body p-0">
                                    <div class="table-responsive table-wrapper">
                                        <table class="table m-0" id="tabeldata">
                                            <thead>
                                                <tr>
                                                    <th style="width: 50px;">No</th>
                                                    <th style="width: 200px;">Tahun</th>
                                                    <th style="width: 200px;">Tanggal</th>
                                                    <th style="width: 250px;">Nama</th>
                                                    <th style="width: 150px;">Opsi</th>
                                                </tr>
                                            </thead>
                                            <template v-for="(datalist, urutlist) in filteredKataData" :key="urutlist">
                                                <tbody>
                                                    <tr>
                                                        <td class="text-center">{{ urutlist + 1 }}</td>
                                                        <td>
                                                            {{ datalist.tahun }}
                                                        </td>
                                                        <td>
                                                            {{ G_formatDateNonWIB(datalist.tanggal) }}
                                                        </td>
                                                        <td>
                                                            <span v-html="datalist.nama"></span>
                                                        </td>
                                                        <td class="text-center">
                                                            <button type="button"
                                                                class="btn btn-primary3 btn-sm lebar2 text-white"
                                                                @click="prosesdata(datalist.id)" data-toggle="tooltip"
                                                                data-placement="left" title="Edit data.."><i
                                                                    class="fas fa-edit"></i> Edit Data</button>
                                                            <button type="button"
                                                                class="btn btn-info3 btn-sm lebar2 text-white"
                                                                @click="hapus(datalist.id)" data-toggle="tooltip"
                                                                data-placement="left" title="Hapus data.."><i
                                                                    class="fas fa-trash-alt"></i> Hapus Data</button>
                                                        </td>
                                                    </tr>
                                                </tbody>
                                            </template>
                                            <tbody v-if="(datapesan == 'data kosong')">
                                                <tr>
                                                    <td colspan="5">Data masih kosong</td>
                                                </tr>
                                            </tbody>
                                        </table>
                                    </div>
                                </div>
                                <div class="card-footer p-3">

                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <Footer />
    </div>
</template>

<script>
import $ from 'jquery';
import axios from 'axios';
import vSelect from 'vue-select';
import swal from 'sweetalert2';
import CryptoJS from 'crypto-js';
import Footer from "../../componen/Footer.vue";
import NavBar from "../../componen/NavBar.vue";
import Menu from "../../componen/Menu.vue";

import VueApexCharts from "vue3-apexcharts";
window.Apex.chart = { fontFamily: "Poppins-SemiBold, Arial, sans-serif" };
export default {
    components: {
        Footer, NavBar, Menu, vSelect, swal
    },
    data() {
        return {
            halamanloading: true,
            iduser: JSON.parse(localStorage.getItem("usistem")),
            leveluser: JSON.parse(localStorage.getItem("lsistem")),
            namauser: JSON.parse(localStorage.getItem("nmusistem")),
            datapesan: '',
            datamaster: [],
            dataapi: [],
            carikata: '',
            project_id: process.env.VUE_APP_PROJECT_ID,
            tahunsekarang: new Date().getFullYear(),
        }
    },
    computed: {
        filteredKataData() {
            const filteredWorkers = this.carikata === ""
                ? this.datamaster
                : this.datamaster.filter(wo => Object.values(wo).join("").toLowerCase().indexOf(this.carikata.toLowerCase()) !== -1);
            return filteredWorkers;
        },
        JumlahfilteredKataData() {
            var jumlah = 0;
            try {
                if (this.filteredKataData === undefined) {
                    jumlah = 0;
                } else {
                    jumlah = this.filteredKataData.length;
                }
            }
            catch {
                jumlah = 0;
            }
            return jumlah;
        },
    },
    methods: {
        getOtentifikasi() {
            var time = Date.parse(localStorage.getItem("tsistem"));
            var timeakhir = time + (3 * 60 * 60 * 1000);
            var timesekarang = Date.parse(new Date());
            if (timesekarang > timeakhir) {
                this.ClearlocalStorage();
            }
        },
        async carilibur() {
            this.halamanloading = true;
            this.dataapi = [];
            const mainAPI = axios.create({
                baseURL: 'https://libur.deno.dev/',
            });
            await mainAPI.get("api?year=" + this.tahunsekarang).then(
                Response => {
                    this.dataapi = Response.data;
                    //alert(JSON.stringify(this.dataapi));
                    //return;
                    this.dataapi.sort((a, b) => new Date(a.date) - new Date(b.date));
                    //alert(this.datapesan);
                    this.halamanloading = false;
                }
            ).catch(error => {
                console.log(error);
                //this.ClearlocalStorage();
                this.halamanloading = false;
            });
        },
        async importapi() {
            this.halamanloading = true;
            this.dataapi = [];
            const mainAPI = axios.create({
                baseURL: 'https://libur.deno.dev/',
            });
            await mainAPI.get("api?year=" + this.tahunsekarang).then(
                Response => {
                    this.dataapi = Response.data;
                    //alert(JSON.stringify(this.dataapi));
                    //return;
                    this.dataapi.sort((a, b) => new Date(a.date) - new Date(b.date));
                    $('#costumModalLegendaData').modal('show');
                    //alert(this.datapesan);
                    this.halamanloading = false;
                }
            ).catch(error => {
                console.log(error);
                //this.ClearlocalStorage();
                this.halamanloading = false;
            });

        },
        async simpantanggal() {
            if (this.dataapi.length == 0) {
                swal.mixin({
                    toast: true,
                    position: 'top-end',
                    showConfirmButton: false,
                    timer: 3000
                }).fire({
                    icon: 'warning',
                    title: 'Data Kosong',
                });
                $('.swal2-container').css("z-index", '999999');
                return false;
            }
            swal.fire({
                title: "Konfirmasi",
                text: "Yakin Hendak Simpan Data?",
                icon: "warning",
                showCancelButton: true,
                cancelButtonText: "Batal",
                confirmButtonColor: "#3a4767",
                cancelButtonColor: "#ffaa05",
                confirmButtonText: "Simpan"
            }).then((result) => {
                if (result.isConfirmed) {
                    var tanggal = '';
                    var nama = '';
                    for (let x = 0; x < this.dataapi.length; x++) {
                        if (x == 0) {
                            tanggal = tanggal + this.dataapi[x].date;
                            nama = nama + this.dataapi[x].name;
                        }
                        else {
                            tanggal = tanggal + '|' + this.dataapi[x].date;
                            nama = nama + '|' + this.dataapi[x].name;
                        }
                    }
                    var fd = new FormData();
                    fd.append("tanggal", tanggal);
                    fd.append("nama", nama);
                    fd.append("project_id", this.project_id);
                    fd.append("createdby", JSON.parse(localStorage.getItem("isistem")));

                    const mainAPI = axios.create({
                        baseURL: process.env.VUE_APP_URL_API,
                        headers: {
                            "Content-Type": "form-data",
                            Authorization: "Bearer " + localStorage.getItem("tokensistem"),
                        },
                    });
                    mainAPI.post("harilibur-Add", fd).then(
                        Response => {
                            if (Response.data.response == 'error') {
                                swal.fire('Peringatan', Response.data.message, 'error');
                                $('.swal2-container').css("z-index", '999999');
                            }
                            else {
                                swal.fire('Informasi', 'Data telah tersimpan..', 'success').then(function () {
                                    window.location.replace("/HariLibur");
                                });
                                $('.swal2-container').css("z-index", '999999');
                            }
                        }
                    ).catch(function (error) {
                        swal.mixin({
                            toast: true,
                            position: 'top-end',
                            showConfirmButton: false,
                            timer: 3000
                        }).fire({
                            icon: 'warning',
                            title: error
                        });
                        $('.swal2-container').css("z-index", '999999');
                    }
                    )

                }
            });
            $('.swal2-container').css("z-index", '999999');
            return false;
        },
        async ambildata() {
            this.halamanloading = true;
            const mainAPI = axios.create({
                baseURL: process.env.VUE_APP_URL_API,
                headers: {
                    Authorization: "Bearer " + localStorage.getItem("tokensistem"),
                },
            });
            var random = Math.random();
            await mainAPI.get("harilibur-GetData?random=" + random + "&project_id=" + this.project_id).then(
                Response => {
                    this.datapesan = Response.data.response;
                    //alert(this.datapesan);
                    if (this.datapesan == 'success') {
                        this.datamaster = [];
                        this.datamaster = Response.data.content.data;
                    }
                    this.halamanloading = false;
                }
            ).catch(error => {
                console.log(error);
                this.ClearlocalStorage();
                this.halamanloading = false;
            });
        },
        prosesdata(kode) {
            var bytes = encodeURIComponent(CryptoJS.AES.encrypt(kode, 'GPMop8LQ06S0rZXcJyEH3wk8jVrINbHwn7tBq2').toString());
            window.location.replace("/ProsesHariLibur/" + bytes);
        },
        hapus(kode) {
            swal.fire({
                title: "Konfirmasi",
                text: "Yakin Hendak Hapus Data?",
                icon: "warning",
                showCancelButton: true,
                cancelButtonText: "Batal",
                confirmButtonColor: "#3a4767",
                cancelButtonColor: "#ffaa05",
                confirmButtonText: "Hapus"
            }).then((result) => {
                if (result.isConfirmed) {
                    const data = { kode: kode, project_id: this.project_id, deletedby: JSON.parse(localStorage.getItem("isistem")) }
                    const mainAPI = axios.create({
                        baseURL: process.env.VUE_APP_URL_API,
                        headers: {
                            Authorization: "Bearer " + localStorage.getItem("tokensistem"),
                            "Content-Type": "application/x-www-form-urlencoded",
                        },
                    });
                    mainAPI.post("harilibur-Hapus", data).then(
                        Response => {
                            if (Response.data.response == 'error') {
                                swal.fire('Peringatan', Response.data.message, 'error');
                            }
                            else {
                                swal.fire('Informasi', 'Data telah dihapus..', 'success').then(function () {
                                    window.location.replace("/HariLibur");
                                });
                            }
                        }
                    ).catch(
                        error => {
                            swal.fire('Peringatan', 'Terjadi Kesalahan Format Data', 'error');
                        }
                    )

                }
            });
            return false;
        },
    },
    mounted() {
        this.getOtentifikasi();
        this.ambildata();
    }
}
</script>
<style></style>